import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BtnBar, CtaBtn, WaitingAlert, DangerAlert } from '@tmapy/style-guide';
import { QUERY_STATE } from '../constants';
import { LocaleContext } from '../LocaleContext';
import { changeFixDimension, clickExport } from './actions';
import { isMapExist } from './selectors';
export const ActionBar = () => {
    const dispatch = useDispatch();
    const formats = useSelector((state) => state.config.formats);
    const queryState = useSelector((state) => state.actionBar.queryState);
    const isMapExistState = useSelector((state) => isMapExist(state));
    const handleFormatClick = useCallback((_, data) => {
        if (isMapExistState) {
            dispatch(changeFixDimension(true, data.data));
        }
        else {
            dispatch(clickExport(null, data.data));
        }
    }, [dispatch, isMapExistState]);
    return (_jsx(LocaleContext.Consumer, { children: (context) => (_jsxs("div", { className: 'sg-u-vs-1', children: [queryState === QUERY_STATE.WAITING && (_jsx(WaitingAlert, { children: `${context.locale.actionBar.waiting}...` })), queryState === QUERY_STATE.FAIL && (_jsx(DangerAlert, { children: context.locale.actionBar.fail })), _jsx(BtnBar, { align: 'left', stretch: true, children: Object.keys(formats).map((k) => (_jsx(CtaBtn, { data: formats[k], isDisabled: queryState === QUERY_STATE.WAITING, onClick: handleFormatClick, children: formats[k].label }, k))) })] })) }));
};
//# sourceMappingURL=component.js.map